import Label from 'components/_parts/atoms/label';
import { Hooks } from 'providers';
import { useContext, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import UseTabs from '../list/useTabs';

function InfoComp(props) {
  const { t } = useTranslation();
  const { tab } = props;
  const { showInfoComp, setShowInfoComp, dataInfoComp } = useContext(Hooks);

  const clickOut = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (clickOut.current && !clickOut?.current?.contains(e.target)) {
        setShowInfoComp(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [clickOut]);

  const labelDetailComp = {
    core_competency: t('job_desc.detail.competencies_core'),
    leadership_competency: t('job_desc.detail.competencies_leadership'),
    functional_competency: t('job_desc.detail.func_compentency'),
    technical_competency: t('job_desc.detail.tech_compentency'),
  };

  return (
    <div
      ref={clickOut}
      className={`custom_option_search ${showInfoComp ? 'show' : ''}`}
      style={{
        width: '70%',
        top: '18%',
        right: '16%',
        boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.3)',
        maxHeight: 'none',
        borderRadius: '20px',
        lineHeight: '1.5',
      }}
    >
      <div
        className="layout_item_search scroll_custom_search"
        style={{ maxHeight: '500px', minHeight: '400px', padding: '20px 30px' }}
      >
        <Label className="mb-1" style={{ fontSize: '10px', color: '#A4A4A4' }}>
          {labelDetailComp[tab]}
        </Label>
        <div className="d-flex justify-content-between mb-3">
          <div className="w-100 pr-2">
            <Label
              className="mb-4"
              typeLabel="fs14fw700"
              style={{ color: '#3D5AFE' }}
            >
              {dataInfoComp.competency_type}
            </Label>
            <Label
              typeLabel="label_option"
              style={{ color: '#4F4F4F', fontFamily: 'poppins' }}
            >
              Deskripsi
            </Label>
            <div
              id="listDetailStructure"
              className="detailJobDesc-modal mt-2"
              dangerouslySetInnerHTML={{
                __html: dataInfoComp.description_sub_skill || '-',
              }}
            />
          </div>
        </div>

        <Label
          className="mb-4"
          typeLabel="fs14fw700"
          style={{ color: '#3D5AFE' }}
        >
          {dataInfoComp.competency_level}
        </Label>

        <div className="d-flex justify-content-between my-4">
          <div className="w-50 pr-2">
            <Label
              typeLabel="label_option"
              style={{ color: '#4F4F4F', fontFamily: 'poppins' }}
            >
              { tab === 'technical_competency' ? 'Performance Criteria' : 'Behaviour Indicator'}
            </Label>
            <div
              id="listDetailStructure"
              className="detailJobDesc-modal mt-2"
              dangerouslySetInnerHTML={{
                __html: dataInfoComp.performance_criteria || '-',
              }}
            />
          </div>

          <div className="w-50 pl-2">
            <Label
              typeLabel="label_option"
              style={{ color: '#4F4F4F', fontFamily: 'poppins' }}
            >
              Knowledge, Skill and Experience Required
            </Label>
            <div
              id="listDetailStructure"
              className="detailJobDesc-modal mt-2"
              dangerouslySetInnerHTML={{ __html: dataInfoComp.experience || '-' }}
            />
          </div>
        </div>
        <div className="d-flex justify-content-between mb-4">
          <div className="w-50 pr-2">
            <Label
              typeLabel="label_option"
              style={{ color: '#4F4F4F', fontFamily: 'poppins' }}
            >
              Learning & Development Required
            </Label>
            <div
              id="listDetailStructure"
              className="detailJobDesc-modal mt-2"
              dangerouslySetInnerHTML={{
                __html: dataInfoComp.learning_development || '-',
              }}
            />
          </div>

          <div className="w-50 pl-2">
            <Label
              typeLabel="label_option"
              style={{ color: '#4F4F4F', fontFamily: 'poppins' }}
            >
              Evidence Required
            </Label>
            <div
              id="listDetailStructure"
              className="detailJobDesc-modal mt-2"
              dangerouslySetInnerHTML={{ __html: dataInfoComp.evidence || '-' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoComp;
